import type {
  earningRuleDetailResource,
  earningRuleResource,
} from '@porotutu/api/features/crm/earning_rules/resource'
import { exportHrefFor, unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { EARNING_RULES } from '@/api/keys'
import type { CrmEarningRuleSort, EarningTrigger } from '../vocabulary'

export type EarningRule = ReturnType<typeof earningRuleResource>
export type EarningRuleDetail = ReturnType<typeof earningRuleDetailResource>

export type EarningRulePage = { data: EarningRule[]; meta: ListMeta }

export type EarningRuleListQuery = ListQuery<CrmEarningRuleSort, never> & {
  campaign_id?: string
  trigger_type?: EarningTrigger
  active?: string
}

const sent = (query: EarningRuleListQuery) => ({
  ...query,
  active: query.active === undefined ? undefined : query.active === 'true',
})

export const earningRulesQuery = (query: EarningRuleListQuery) =>
  queryOptions({
    queryKey: [...EARNING_RULES, 'list', query] as const,
    queryFn: async () => unwrap(await crm['earning-rules'].get({ query: sent(query) })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })

export const earningRuleQuery = (id: string) =>
  queryOptions({
    queryKey: [...EARNING_RULES, 'record', id] as const,
    queryFn: async () => unwrap(await crm['earning-rules']({ id }).get()),
    staleTime: 30_000,
  })

export const exportHref = exportHrefFor<EarningRuleListQuery>('/api/v1/crm/earning-rules/export', {
  always: ['campaign_id'],
  viewed: ['trigger_type', 'active', 'search'],
})
